import { SxProps } from "@mui/material";

export const wrapperMain: SxProps = {
  height: "100vh",
  overflow: "hidden",
  // "@media (max-width: 1200px)": {
  //   height: "unset",
  // },
};
